import {
  collection,
  where,
  getFirestore,
  getDocs,
  query,
  setDoc,
  getDoc,
  deleteDoc,
  serverTimestamp,
  doc,
  updateDoc,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./request.type";

const firestore = getFirestore(app);
const auth = getAuth();

// -------------- get All request by Owner -------------- //
let reqSub = [];
export const snapAllRequestByOwner = (callback) => (dispatch) => {
  const owner = auth?.currentUser?.uid;
  console.log({ owner });
  const cRef = collection(firestore, REF.REQUEST);
  const c0 = where("owner", "==", owner);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      selectAllRequestSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  reqSub.push(unsub);
};

export const unSnapReq = () => (dispatch) => {
  reqSub.forEach((subscriber) => {
    subscriber();
  });

  reqSub.length = 0;
};

// -------------- dispatch -------------- //
const selectAllRequestSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_REQUEST_SUCCESS,
    payload: data,
  });
};

// -------------- Update the request info -------------- //

export const updateRequest =
  ({ update }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.REQUEST);
    const id = update?.id;
    const updated = {
      ...update,
      updateAt: serverTimestamp(),
    };

    const dRef = doc(cRef, id);
    updateDoc(dRef, updated)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err.message || "Please try again!",
          });
        }
      });
  };

// -------------- get count request by Owner -------------- //
let countSub = [];
export const snapCountRequestByOwner = (callback) => (dispatch) => {
  const owner = auth?.currentUser?.uid;
  const cRef = collection(firestore, REF.REQUEST);
  const c0 = where("owner", "==", owner);
  const c1 = where("status", "==", "Sent");
  const qRef = query(cRef, c0, c1);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      const count = data?.length || 0;
      selectCountReqSuccess(dispatch, count);
      if (callback) {
        callback();
      }
    }
  });
  countSub.push(unsub);
};

export const unSnapCountReq = () => (dispatch) => {
  countSub.forEach((subscriber) => {
    subscriber();
  });

  countSub.length = 0;
};

// -------------- dispatch -------------- //
const selectCountReqSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.GET_COUNT_REQUEST_SUCCESS,
    payload: data,
  });
};
